import { render, staticRenderFns } from "./DuplicateCatalog.vue?vue&type=template&id=51afa50c&scoped=true"
import script from "./DuplicateCatalog.vue?vue&type=script&lang=js"
export * from "./DuplicateCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afa50c",
  null
  
)

export default component.exports